/* @flow */
import React, { Component } from 'react';
import {connect} from 'react-redux';
import './stats.css';
import moment from 'moment';
import axios from 'axios';
import Pending from './stats/pending.js';
import Container from './stats/container.js';

class Stats extends Component {

  constructor(props) {
    super(props);
    this.dates = {};
    this.data = {};
    this.parametersChanged = this.parametersChanged.bind(this);
    this.state = { dataLoaded: false };
  }

  getDatesObjectFromHash() {
    const hash = this.props.location.hash;
    let dateFrom, dateTo;
    let days = 30;
    let custom = false;
    let m = /\bdate-from=(\d\d\d\d-\d\d-\d\d)&date-to=(\d\d\d\d-\d\d-\d\d)\b/.exec(hash);
    if (m) {
      dateFrom = moment(m[1], 'YYYY-MM-DD');
      dateTo = moment(m[2], 'YYYY-MM-DD');
      days = dateTo.diff(dateFrom, 'days') + 1;
      custom = true;
    } else {
      m = /\bdays=(\d+)\b/.exec(hash);
      if (m) days = parseInt(m[1], 10);
      dateTo = moment().startOf('day');
      dateTo.subtract(1, 'days');
      dateFrom = moment(dateTo);
      dateFrom.subtract(days - 1, 'days');
    }
    return { dateFrom, dateTo, days, custom };
  }

  getData() {
    this.dates = this.getDatesObjectFromHash();
    const client = this.props.httpClient;
    const ep = this.props.endpoints;
    const dateFrom = this.dates.dateFrom;
    const dateTo = this.dates.dateTo;
    const dateXFrom = moment(dateFrom);
    dateXFrom.subtract(this.dates.days, 'days');
    const fromXFormatted = dateXFrom.format('YYYY-MM-DD');
    const fromFormatted = dateFrom.format('YYYY-MM-DD');
    const toFormatted = dateTo.format('YYYY-MM-DD');
    const headers = {
      'X-Folksy-User-ID': this.props.folksyUserId,
      'X-Folksy-User-Token': this.props.folksyUserToken,
    };
    const getSfData = () => client({
      url: ep.statsShopFrames(fromXFormatted, toFormatted),
      method: 'GET',
      headers,
    });
    const getOData = () => client({
      url: ep.statsOrders(fromXFormatted, toFormatted),
      method: 'GET',
      headers,
    });
    axios.all([getSfData(), getOData()])
      .then(axios.spread((sfResponse, oResponse) => {
        // console.log(sfResponse);
        // console.log(oResponse);
        let cFrames = [], pFrames = [], cOrders = [], pOrders = [];
        for (let frame of sfResponse.data)
          frame['recorded_on'] >= fromFormatted ? cFrames.push(frame) : pFrames.push(frame);
        for (let order of oResponse.data['orders'])
          order['ordered_on'] >= fromFormatted ? cOrders.push(order) : pOrders.push(order);
        this.data = {
          cFrames: cFrames,
          pFrames: pFrames,
          cOrders: cOrders,
          pOrders: pOrders,
          totalOrderItems: oResponse.data['total_orders'],
          totalRevenue: oResponse.data['total_revenue'],
        };
        this.setState({ dataLoaded: true });
      }));
  }

  parametersChanged(e: SyntheticEvent) {
    this.setState({ dataLoaded: false });
  }

  render() {
    if (this.props.user.isSeller) {
      if (this.state.dataLoaded) {
        return (
          <Container {...this.props} 
            cFrames={this.data.cFrames}
            pFrames={this.data.pFrames}
            cOrders={this.data.cOrders}
            pOrders={this.data.pOrders}
            totalOrderItems={this.data.totalOrderItems}
            totalRevenue={this.data.totalRevenue}
            dates={{
              from: this.dates.dateFrom,
              to: this.dates.dateTo,
              days: this.dates.days,
              custom: this.dates.custom,
            }}
            changeDays={this.changeDays}
            changeCustomDays={this.changeCustomDays}
            parametersChanged={this.parametersChanged}
            location={this.props.location}
          />
        );
      } else {
        this.getData();
        return <Pending/>;
      }
    } else {
      window.location = this.props.endpoints.login();
    }
  }
}

const mapStateToProps = state => ({
  folksyUserId: state.auth.user.id,
  folksyUserToken: state.auth.user.token,
});

export default connect(mapStateToProps)(Stats);



// WEBPACK FOOTER //
// ./src/app/stats.js